import { useEffect, useRef, useState } from 'react';

/**
 * 自定义Hook，用于检测组件是否首次进入
 *
 * @returns 返回一个ref对象，其current属性表示是否为首次进入状态
 *          初始值为true，组件渲染后会更新为false
 */
export function useFirstEnter() {
  // 状态变量，用于跟踪是否首次进入
  const [isFirstEnter, setIsFirstEnter] = useState(true);
  // ref对象，用于存储首次进入状态的持久化引用
  const firstEnterRef = useRef(isFirstEnter);

  // 组件挂载后，将首次进入状态设置为false
  useEffect(() => {
    setIsFirstEnter(false);
  }, []);

  // 当首次进入状态发生变化时，同步更新ref中的值
  useEffect(() => {
    if (!isFirstEnter) {
      firstEnterRef.current = isFirstEnter;
    }
  }, [isFirstEnter]);

  return firstEnterRef;
}
